// extracted by mini-css-extract-plugin
module.exports = {"displayMessage":"src-lib-app-containers-SSOLogin-Request-style-module__displayMessage--3jONJ","header2":"src-lib-app-containers-SSOLogin-Request-style-module__header2--3-fXt"};